import PredictionCalculator from './prediction-calculator';

export default PredictionCalculator;
